<template>
	<div class="item-hover" @click="onClick">
		<div class="worklist-item-xs" v-if="$vuetify.breakpoint.xs">
			<div>
				<div class="name">{{ worklist.name === 'All live jobs' ? 'All Live and Proposed jobs' : worklist.name }}</div>
				<div>
					<span class="detail-xs" v-if="worklist.is_dynamic">dynamic</span>
					<span class="detail-xs" v-if="worklist.is_owned">, my worklist</span>
					<span class="detail-xs" v-if="!worklist.is_owned">, {{ worklist.owner }}'s worklist</span>
				</div>
			</div>
			<v-spacer></v-spacer>
			<div class="control-btn-xs">
				<div class="able" v-if="is_pin"  @click.stop="onSetPin(false)">
					<Pin color="rgba(25, 42, 62, 0.7)" class="icon"/>
				</div>
				<div class="able" v-else @click.stop="onSetPin(true)">
					<UnPin color="rgba(25, 42, 62, 0.7)" class="icon"/>
				</div>
				<v-bottom-sheet>
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on">
							<MoreHoriz color="rgba(25, 42, 62, 0.7)" class="icon"/>
						</div>
					</template>
					<v-sheet class="control-panel">
						<div class="control-panel-item">
							<div class="control-panel-item-i">
								<Pin v-if="is_pin" class="mr-7"  color="rgba(25, 42, 62, 0.7)" width="18" hight="18"/>
								<UnPin v-else class="mr-7" color="rgba(25, 42, 62, 0.7)" width="18" hight="18"/>
								<div>Pin</div>
							</div>
							<v-switch
								color="info"
								insets
								v-model="is_pin"
								@change="onChangePin"
							></v-switch>
						</div>
						<div class="control-panel-item">
							<div class="control-panel-item-i" @click.stop="onEdit">
								<EditIcon class="mr-7" :color="worklist.is_owned ? 'rgba(25, 42, 62, 0.7)': 'rgba(25, 42, 62, 0.2)'" width="18" hight="18"/>
								<div :class="worklist.is_owned ? 'able': 'disable'">Rename</div>
							</div>
						</div>
						<div class="control-panel-item">
							<div class="control-panel-item-i">
								<Hide v-if="is_hide" class="mr-7" color="rgba(25, 42, 62, 0.7)" width="18" hight="18"/>
								<UnHide v-else class="mr-7" color="rgba(25, 42, 62, 0.7)" width="18" hight="18"/>
								<div>Hide</div>
							</div>
							<v-switch
								color="info"
								insets
								v-model="is_hide"
								@change="onChangeHide"
							></v-switch>
						</div>
						<div class="control-panel-item">
							<div class="control-panel-item-i" @click.stop="onDelete">
								<Delete class="mr-7" :color="worklist.is_owned ? '#EE0202': 'rgba(25, 42, 62, 0.2)'" width="18" hight="18"/>
								<div :class="worklist.is_owned ? 'text-del': 'disable'">Delete</div>
							</div>
						</div>
					</v-sheet>
				</v-bottom-sheet>
			</div>
		</div>
		<div class="worklist-item" v-if="$vuetify.breakpoint.smAndUp">
			<div class="item-desc">
				<span class="name">{{ worklist.name === 'All live jobs' ? 'All Live and Proposed jobs' : worklist.name }}</span>
				<span class="detail" v-if="worklist.is_dynamic">, dynamic</span>
				<span class="detail" v-if="worklist.is_owned">, my worklist</span>
				<span class="detail" v-if="!worklist.is_owned">, {{ worklist.owner }}'s worklist</span>
			</div>
			<v-spacer></v-spacer>
			<div class="control-btn">
				<div class="able" v-if="is_pin"  @click.stop="onSetPin(false)">
					<Pin color="rgba(25, 42, 62, 0.7)" class="icon"/>Unpin
				</div>
				<div class="able" v-else @click.stop="onSetPin(true)">
					<UnPin color="rgba(25, 42, 62, 0.7)" class="icon"/>Pin
				</div>
				<div :class="worklist.is_owned ? 'able': 'disable'" @click.stop="onEdit">
					<EditIcon :color="worklist.is_owned ? 'rgba(25, 42, 62, 0.7)': 'rgba(25, 42, 62, 0.2)'" class="icon" />Rename
				</div>
				<div class="able" v-if="is_hide" @click.stop="onSetHide(false)">
					<Hide color="rgba(25, 42, 62, 0.7)" class="icon"/>Show
				</div>
				<div class="able" v-else @click.stop="onSetHide(true)">
					<UnHide color="rgba(25, 42, 62, 0.7)" class="icon"/>Hide
				</div>
				<div :class="worklist.is_owned ? 'able': 'disable'" @click.stop="onDelete">
					<Delete class="icon" :color="worklist.is_owned ? 'rgba(25, 42, 62, 0.7)': 'rgba(25, 42, 62, 0.2)'"/>Delete
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import UnPin from '@/components/icons/unpin';
import Pin from '@/components/icons/pin';
import EditIcon from '@/components/icons/edit_icon';
import Hide from '@/components/icons/hide';
import UnHide from '@/components/icons/unhide';
import Delete from '@/components/icons/delete_outline';
import MoreHoriz from '@/components/icons/more-horiz';

export default {
	name: 'WorklistItem',
	props: {
		worklist: {
			type: Object,
			default: () => {}
		},
		mini: {
			type: Boolean,
			default: true,
		}
	},
	components: {
		UnPin, Pin, EditIcon, Hide, UnHide, Delete, MoreHoriz
	},
	data() {
		return {
			is_pin: this.worklist.is_pinned,
			is_hide: this.worklist.is_hidden,
		}
	},
	methods: {
		onEdit() {
			if (this.worklist.is_owned) {
				this.$emit('rename', this.worklist);
			}
		},
		onDelete() {
			if (this.worklist.is_owned) {
				this.$emit('delete', this.worklist.id);
			}
		},
		onChangePin(event) {
			this.onSetPin(event, true);
		},
		onChangeHide(event) {
			this.onSetHide(event, true);
		},
		onClick() {
			this.$emit('click', this.worklist.id)
		},
		onSetPin(setting, is_switch=false) {
			const url = `/api/worklists/${this.worklist.id}/pinned`;
			this._setting(url, setting, true, is_switch);
		},
		onSetHide(setting, is_switch=false) {
			const url = `/api/worklists/${this.worklist.id}/hidden`;
			this._setting(url, setting, false, is_switch);
		},
		_setting(url, setting, is_pin, is_switch=false) {
			axios
				.put(url, {
					enabled: setting
				}, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then(val =>  {
					const {status, reason} = val.data;

					if (status == "OK") {
						if (is_pin) {
							if (!is_switch) {
								this.is_pin = !this.is_pin;
							}
							
							if (this.worklist.class == 'restful.jobs.worklists') {
								this.$store.dispatch('update_pinned_job_worklists');
							} else if (self.worklist.class == 'restful.addressbook.worklists') {
								this.$store.dispatch('update_pinned_abook_worklists');
							} else if (self.worklist.class == 'restful.tasks.lists') {
								this.$store.dispatch('update_pinned_tasks_worklists');
							}

						} else {
							if (!is_switch) {
								this.is_hide = !this.is_hide;
							}
							this.$emit('hide-changed');
						}
						
					} else {
						this.$emit('err-msg', reason);
					}
				})
				.catch((e) => {
					this.$emit('err-msg', e);
				});
		}
	}
  
}
</script>
<style lang="scss" scoped>
.worklist-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  margin: 8px 0;
  background: #FFFFFF;
  border-radius: 4px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.worklist-item-xs {
	display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
	padding: 10px 20px;
  margin: 8px 0;
  background: #FFFFFF;
  border-radius: 4px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.name {
	font-weight: 500;
}
.detail {
	color: rgba(25, 42, 62, 0.5);
}
.detail-xs {
	color: rgba(25, 42, 62, 0.5);
	font-size: 12px;
}
.item-desc {
	width: 45%;
	word-break: normal;
}
.control-btn {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 320px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: rgba(25, 42, 62, 0.7);

  div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    margin: 4px 8px;
		width: 25%;
  }
}
.control-btn-xs {
	display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  color: rgba(25, 42, 62, 0.7);
  div {
    margin: 4px 8px;
  }
}
.able {
  color: rgba(25, 42, 62, 0.7);
  &:hover {
    cursor: pointer;
  }
}
.disable {
  color: rgba(25, 42, 62, 0.3);
}
.icon {
  width: 24px;
  height: 24px;
  margin-right: 4px;
}
.control-panel {
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
	justify-content: center;
	padding: 10px 30px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: #192A3E;


	.control-panel-item {
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;
	}
}
.control-panel-item-i {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
}
.text-del {
	color: #EE0202;
}
.item-hover {
	:hover {
		background-color: #FAFAFA;
	}
}

</style>